import { useCallback, useState } from "react";
import { ValueAction } from "@components/TabBofu/DocumentsTabBofu";
import { BofuTabDocument, DocumentResponse } from "@interfaces/index";

type UpdateDocumentParams = {
  document: BofuTabDocument;
  newValue: DocumentResponse | undefined;
};

type UpdateDocumentMultipleParams = {
  document: BofuTabDocument;
  newValue: DocumentResponse | undefined;
  valueAction?: ValueAction;
  valueIndex?: number;
};

const findDocumentIndex = (documents: BofuTabDocument[], document: BofuTabDocument) =>
  documents.findIndex((doc) => doc.file_category_code === document.file_category_code);

const useExpedienteDocuments = (initialDocuments: BofuTabDocument[] = []) => {
  const [expedienteDocuments, setExpedienteDocuments] = useState<BofuTabDocument[]>(initialDocuments);

  const handleUpdateDocument = useCallback(({ document, newValue }: UpdateDocumentParams) => {
    setExpedienteDocuments((prev) => {
      const copy = [...prev];
      const documentIndex = findDocumentIndex(copy, document);
      if (documentIndex === -1) {
        return prev;
      }

      copy[documentIndex] = {
        ...copy[documentIndex],
        file_value: newValue,
      };
      return copy;
    });
  }, []);

  const handleUpdateDocumentMultiple = useCallback(
    ({ document, newValue, valueAction, valueIndex }: UpdateDocumentMultipleParams) => {
      if (!valueAction) {
        return;
      }

      setExpedienteDocuments((prev) => {
        const copy = [...prev];
        const documentIndex = findDocumentIndex(copy, document);
        if (documentIndex === -1) {
          return prev;
        }

        const currentDocument = { ...copy[documentIndex] };
        const listValues = [...(currentDocument.list_values ?? [])];

        if (valueAction === "add") {
          listValues.push(newValue);
        } else if (valueAction === "remove" && valueIndex !== undefined) {
          listValues.splice(valueIndex, 1);
        } else if (valueAction === "update" && valueIndex !== undefined) {
          listValues[valueIndex] = newValue;
        } else {
          return prev;
        }

        copy[documentIndex] = {
          ...currentDocument,
          list_values: listValues,
        };
        return copy;
      });
    },
    [],
  );

  return {
    expedienteDocuments,
    setExpedienteDocuments,
    handleUpdateDocument,
    handleUpdateDocumentMultiple,
  };
};

export default useExpedienteDocuments;
